<template>
<div id="midialog">
  <v-toolbar flat color="white">
    <v-toolbar-title>Juzgados</v-toolbar-title>
    <v-divider
      class="mx-4"
      inset
      vertical
    ></v-divider>
    <div class="flex-grow-1"></div>
    <v-dialog v-model="dialog" persistent>
      <v-form ref="form" v-model="valid">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Actualizar</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline"> Actualizar Juzgados</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                      <v-text-field
                        outlined
                        v-model="juzgado.nombre"
                        label="Nombre"
                        required
                        :rules="[v => !!v || 'Campo requerido']"
                        @input="v => { juzgado.nombre = v.toUpperCase() }"
                        ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        outlined
                        v-model="juzgado.clave"
                        label="Clave"
                        required
                        :rules="[v => !!v || 'Campo requerido']"
                        @input="v => { juzgado.clave = v.toUpperCase() }"

                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        outlined
                        v-model="juzgado.materia"
                        label="Materia"
                        required
                        :rules="[v => !!v || 'Campo requerido']"
                        @input="v => { juzgado.materia = v.toUpperCase() }"
                        ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="getAllMunicipios"
                        item-text="nombre"
                        item-value="id"
                        label="Municipio"
                        persistent-hint
                        v-model="juzgado.municipio_id"
                        outlined
                        required
                        :rules="[v => !!v || 'Campo requerido']"
                      >
                      </v-select>
                    </v-col>
                  </v-row>

                <v-col cols="12">
                  <v-checkbox v-model="activo" label="Activo" :value="activo"></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
            <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-toolbar>

</div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import BaseSelect from "../../components/BaseSelect.vue";

export default {
  components: {
    BaseSelect
  },
  data() {
    return {
      valid: true,
      dialog: false,
      activo: true,
      juzgado: {}
    };
  },
  computed: {
    ...mapGetters(["getJuzgadoSelected", "getAllMunicipios"])
  },
  created() {
    this.juzgado = this.$store.state.catJuzgados.juzgado_selected;
    if (this.juzgado.deleted_at) {
      this.activo = false
    }else {
      this.activo = true
    }
    this.$store.dispatch("GET_ALL_MUNICIPIOS", { url: "municipios" });
    if (!this.juzgado.id) {
      this.$router.push({ name: "Juzgados" });
    }
  },
  mounted() {
    this.dialog = true;
  },
  methods: {
    close() {
      this.dialog = false;
      return this.$router.push({ name: "Juzgados" });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.juzgado.activo = this.activo
        this.$store.dispatch("EDIT_JUZGADO",  { url: "/juzgado/" +  this.juzgado.id, data: this.juzgado } ).then(res => {
          this.$swal({
            title: "Exito!!!",
            text: res.data.message,
            icon: "success",
            confirmButtonText: "Aceptar"
          });
          this.$router.push({ name: "Juzgados" });
        })
        .catch(error => {
          this.$swal({
            title: "Error!!!",
            text: error.response.data.message,
            icon: 'warning',
            confirmButtonText: "Aceptar"
          })
        });
      }
    }
  }
};
</script>
